(function($) {

    $("p:not('[data-aos], .no-aos'), h1:not('[data-aos], .no-aos'), h2:not(.no-aos), h3:not(.no-aos), h4, h5, h6, .fade-in-text").each(function () {
        $(this).attr("data-aos", "fade-up");
    })

    $(window).load(function() {
        setTimeout(function() {
            AOS.refresh();
        }, 500);
    });

})( jQuery );


AOS.init({
    once: true,
    duration: 800
});